function NotGreenCounty({ county }) {
  return (
    <>
      <div className="card-body">
        <h5 className="card-text">
          This is considered a grey or blue county, where YoungLife currently
          has no presence or a developing presence. If you have questions,
          ideas, contacts, etc. for this area, please contact us!
        </h5>
        <a
          href="http://giving.younglife.org/mountainstate"
          target="_blank"
          rel="noreferrer noopener"
          className="btn btn-primary btn-sm col-sm-8 my-2 text-secondary"
        >
          Give to YL starting
        </a>
      </div>
    </>
  );
}

export default NotGreenCounty;
